/**
 * City Data Configuration
 * Central source of truth for all city information used in SEO
 */

import { CityData } from '../types/city.types';

export const cityDataMap: Record<string, CityData> = {
  // Tier 1 Cities (High Priority)
  mumbai: {
    id: "6e67d6c8-8ad0-4136-a2fc-0b75aa1d531e",
    name: "Mumbai",
    slug: "mumbai",
    state: "Maharashtra",
    latitude: 19.0760,
    longitude: 72.8777,
    alternateNames: ["Bombay"],
    keywords: [
      "turf booking mumbai",
      "cricket turf mumbai",
      "football turf mumbai",
      "box cricket mumbai",
      "sports ground mumbai",
      "turf near me mumbai",
      "online turf booking mumbai",
      "book turf mumbai",
      "cricket ground mumbai",
      "football ground mumbai"
    ],
    tier: 1,
    showBookNow: true
  },
  delhi: {
    id: "14c0b861-05bd-4837-b845-55b2ed86d981",
    name: "Delhi",
    slug: "delhi",
    state: "Delhi",
    latitude: 28.6139,
    longitude: 77.2090,
    alternateNames: ["New Delhi"],
    keywords: [
      "turf booking delhi",
      "cricket turf delhi",
      "football turf delhi",
      "box cricket delhi",
      "sports ground delhi",
      "turf near me delhi",
      "online turf booking delhi",
      "book turf delhi",
      "cricket ground delhi",
      "sports venue delhi"
    ],
    tier: 1,
    showBookNow: true
  },
  bengaluru: {
    id: "ba80a131-8750-4b89-8464-d2f57638faab",
    name: "Bengaluru",
    slug: "bengaluru",
    state: "Karnataka",
    latitude: 12.9716,
    longitude: 77.5946,
    alternateNames: ["Bangalore"],
    keywords: [
      "turf booking bengaluru",
      "turf booking bangalore",
      "cricket turf bengaluru",
      "football turf bengaluru",
      "box cricket bengaluru",
      "sports ground bengaluru",
      "turf near me bengaluru",
      "online turf booking bengaluru"
    ],
    tier: 1,
    showBookNow: false
  },
  hyderabad: {
    id: "fc8e368d-a4bc-461d-ba2c-f2bbdd420ffe",
    name: "Hyderabad",
    slug: "hyderabad",
    state: "Telangana",
    latitude: 17.3850,
    longitude: 78.4867,
    keywords: [
      "turf booking hyderabad",
      "cricket turf hyderabad",
      "football turf hyderabad",
      "box cricket hyderabad",
      "sports ground hyderabad",
      "turf near me hyderabad",
      "online turf booking hyderabad",
      "book turf hyderabad"
    ],
    tier: 1,
    showBookNow: true
  },
  kolkata: {
    id: "e734b648-25b3-4a09-9eea-565648765206",
    name: "Kolkata",
    slug: "kolkata",
    state: "West Bengal",
    latitude: 22.5726,
    longitude: 88.3639,
    alternateNames: ["Calcutta"],
    keywords: [
      "turf booking kolkata",
      "cricket turf kolkata",
      "football turf kolkata",
      "box cricket kolkata",
      "sports ground kolkata",
      "turf near me kolkata",
      "online turf booking kolkata"
    ],
    tier: 1,
    showBookNow: true
  },
  pune: {
    id: "87ec828a-4458-4301-a86c-11da89b33fd3",
    name: "Pune",
    slug: "pune",
    state: "Maharashtra",
    latitude: 18.5204,
    longitude: 73.8567,
    alternateNames: ["Poona"],
    keywords: [
      "turf booking pune",
      "cricket turf pune",
      "football turf pune",
      "box cricket pune",
      "sports ground pune",
      "turf near me pune",
      "online turf booking pune",
      "book turf pune"
    ],
    tier: 1,
    showBookNow: true
  },
  ahmedabad: {
    id: "71eb5dc8-2e64-4845-a355-b046e223cba5",
    name: "Ahmedabad",
    slug: "ahmedabad",
    state: "Gujarat",
    latitude: 23.0225,
    longitude: 72.5714,
    keywords: [
      "turf booking ahmedabad",
      "cricket turf ahmedabad",
      "football turf ahmedabad",
      "box cricket ahmedabad",
      "sports ground ahmedabad",
      "turf near me ahmedabad",
      "online turf booking ahmedabad"
    ],
    tier: 1,
    showBookNow: true
  },
  gurugram: {
    id: "f7fd3bae-a88d-410b-8031-9f7de291fdbb",
    name: "Gurugram",
    slug: "gurugram",
    state: "Haryana",
    latitude: 28.4089,
    longitude: 77.0378,
    alternateNames: ["Gurgaon"],
    keywords: [
      "turf booking gurugram",
      "turf booking gurgaon",
      "cricket turf gurugram",
      "football turf gurugram",
      "box cricket gurugram",
      "sports ground gurugram",
      "turf near me gurugram",
      "online turf booking gurugram"
    ],
    tier: 1,
    showBookNow: false
  },
  noida: {
    id: "58e5f7b2-dfd3-42c0-bfc3-c0baa0e07922",
    name: "Noida",
    slug: "noida",
    state: "Uttar Pradesh",
    latitude: 28.5355,
    longitude: 77.3910,
    keywords: [
      "turf booking noida",
      "cricket turf noida",
      "football turf noida",
      "box cricket noida",
      "sports ground noida",
      "turf near me noida",
      "online turf booking noida"
    ],
    tier: 1,
    showBookNow: false
  },
  jaipur: {
    id: "1824d5cc-f783-4b29-8dc3-1855af0c86a6",
    name: "Jaipur",
    slug: "jaipur",
    state: "Rajasthan",
    latitude: 26.9124,
    longitude: 75.7873,
    keywords: [
      "turf booking jaipur",
      "cricket turf jaipur",
      "football turf jaipur",
      "box cricket jaipur",
      "sports ground jaipur",
      "turf near me jaipur",
      "online turf booking jaipur"
    ],
    tier: 1,
    showBookNow: true
  },

  // Tier 2 Cities (Medium Priority)
  indore: {
    id: "bb0a9506-8f85-4c38-a18c-3b0ab21b955e",
    name: "Indore",
    slug: "indore",
    state: "Madhya Pradesh",
    latitude: 22.7196,
    longitude: 75.8577,
    keywords: [
      "turf booking indore",
      "cricket turf indore",
      "football turf indore",
      "box cricket indore",
      "sports ground indore",
      "turf near me indore",
      "online turf booking indore",
      "book turf indore"
    ],
    tier: 2,
    showBookNow: true
  },
  bhopal: {
    id: "497e3c29-9ed1-4057-a3ca-e76603999750",
    name: "Bhopal",
    slug: "bhopal",
    state: "Madhya Pradesh",
    latitude: 23.2599,
    longitude: 77.4126,
    keywords: [
      "turf booking bhopal",
      "cricket turf bhopal",
      "football turf bhopal",
      "box cricket bhopal",
      "sports ground bhopal",
      "turf near me bhopal",
      "online turf booking bhopal"
    ],
    tier: 2,
    showBookNow: true
  },
  surat: {
    id: "032330e8-3e32-46d1-9209-aea7dea48473",
    name: "Surat",
    slug: "surat",
    state: "Gujarat",
    latitude: 21.1702,
    longitude: 72.8311,
    keywords: [
      "turf booking surat",
      "cricket turf surat",
      "football turf surat",
      "box cricket surat",
      "sports ground surat",
      "turf near me surat",
      "online turf booking surat"
    ],
    tier: 2,
    showBookNow: true
  },
  vadodara: {
    id: "94605432-7927-4946-82ae-3e3cfc9755d6",
    name: "Vadodara",
    slug: "vadodara",
    state: "Gujarat",
    latitude: 22.3072,
    longitude: 73.1812,
    alternateNames: ["Baroda"],
    keywords: [
      "turf booking vadodara",
      "cricket turf vadodara",
      "football turf vadodara",
      "box cricket vadodara",
      "sports ground vadodara",
      "turf near me vadodara",
      "online turf booking vadodara"
    ],
    tier: 2,
    showBookNow: true
  },
  coimbatore: {
    id: "90fc32c2-49f7-4fcb-a18e-78b8da3107bb",
    name: "Coimbatore",
    slug: "coimbatore",
    state: "Tamil Nadu",
    latitude: 11.0168,
    longitude: 76.9558,
    keywords: [
      "turf booking coimbatore",
      "cricket turf coimbatore",
      "football turf coimbatore",
      "box cricket coimbatore",
      "sports ground coimbatore",
      "turf near me coimbatore",
      "online turf booking coimbatore"
    ],
    tier: 2,
    showBookNow: false
  },
  thane: {
    id: "38faff2e-62e6-4ab0-860d-a92e2e19e5b7",
    name: "Thane",
    slug: "thane",
    state: "Maharashtra",
    latitude: 19.2183,
    longitude: 72.9781,
    keywords: [
      "turf booking thane",
      "cricket turf thane",
      "football turf thane",
      "box cricket thane",
      "sports ground thane",
      "turf near me thane",
      "online turf booking thane"
    ],
    tier: 2,
    showBookNow: true
  },
  udaipur: {
    id: "64e7e2da-8e2e-41a5-ad11-88f328c59d3f",
    name: "Udaipur",
    slug: "udaipur",
    state: "Rajasthan",
    latitude: 24.5854,
    longitude: 73.7125,
    keywords: [
      "turf booking udaipur",
      "cricket turf udaipur",
      "football turf udaipur",
      "box cricket udaipur",
      "sports ground udaipur",
      "turf near me udaipur",
      "online turf booking udaipur"
    ],
    tier: 2,
    showBookNow: true
  },
  kota: {
    id: "9000e5c9-1cc1-48b3-9590-a85360f50928",
    name: "Kota",
    slug: "kota",
    state: "Rajasthan",
    latitude: 25.2138,
    longitude: 75.8648,
    keywords: [
      "turf booking kota",
      "cricket turf kota",
      "football turf kota",
      "box cricket kota",
      "sports ground kota",
      "turf near me kota",
      "online turf booking kota"
    ],
    tier: 2,
    showBookNow: false
  },
  gwalior: {
    id: "aeba0e10-2961-4094-81c0-73e5478f1494",
    name: "Gwalior",
    slug: "gwalior",
    state: "Madhya Pradesh",
    latitude: 26.2183,
    longitude: 78.1828,
    keywords: [
      "turf booking gwalior",
      "cricket turf gwalior",
      "football turf gwalior",
      "box cricket gwalior",
      "sports ground gwalior",
      "turf near me gwalior",
      "online turf booking gwalior"
    ],
    tier: 2,
    showBookNow: false
  },
  thiruvananthapuram: {
    id: "3c2b6a30-edce-478d-b0f4-471447ebf20a",
    name: "Thiruvananthapuram",
    slug: "thiruvananthapuram",
    state: "Kerala",
    latitude: 8.5241,
    longitude: 76.9366,
    alternateNames: ["Trivandrum"],
    keywords: [
      "turf booking trivandrum",
      "turf booking thiruvananthapuram",
      "cricket turf trivandrum",
      "cricket turf thiruvananthapuram",
      "football turf trivandrum",
      "football turf thiruvananthapuram",
      "box cricket trivandrum",
      "box cricket thiruvananthapuram",
      "sports ground trivandrum",
      "sports ground thiruvananthapuram",
      "turf near me trivandrum",
      "turf near me thiruvananthapuram"
    ],
    tier: 2,
    showBookNow: true
  },

  // Tier 3 Cities (Lower Priority)
  ujjain: {
    id: "7ab0a344-c415-4444-a1f0-5d16ea136d1e",
    name: "Ujjain",
    slug: "ujjain",
    state: "Madhya Pradesh",
    latitude: 23.1765,
    longitude: 75.7885,
    keywords: [
      "turf booking ujjain",
      "cricket turf ujjain",
      "football turf ujjain",
      "box cricket ujjain",
      "sports ground ujjain",
      "turf near me ujjain",
      "online turf booking ujjain"
    ],
    tier: 3,
    showBookNow: true
  },
  dewas: {
    id: "73562521-9522-478c-a35e-15783383055b",
    name: "Dewas",
    slug: "dewas",
    state: "Madhya Pradesh",
    latitude: 22.9650,
    longitude: 76.0550,
    keywords: [
      "turf booking dewas",
      "cricket turf dewas",
      "football turf dewas",
      "box cricket dewas",
      "sports ground dewas",
      "turf near me dewas",
      "online turf booking dewas"
    ],
    tier: 3,
    showBookNow: true
  },
  betma: {
    id: "2f8f6d79-9d97-48fe-8367-ee8672a7fa20",
    name: "Betma",
    slug: "betma",
    state: "Madhya Pradesh",
    latitude: 22.6833,
    longitude: 75.6167,
    keywords: [
      "turf booking betma",
      "cricket turf betma",
      "football turf betma",
      "box cricket betma",
      "sports ground betma",
      "turf near me betma"
    ],
    tier: 3,
    showBookNow: true
  },
  mandsaur: {
    id: "051e665f-9fcd-42f8-a9da-686c8ad54360",
    name: "Mandsaur",
    slug: "mandsaur",
    state: "Madhya Pradesh",
    latitude: 24.0717,
    longitude: 75.0697,
    keywords: [
      "turf booking mandsaur",
      "cricket turf mandsaur",
      "football turf mandsaur",
      "box cricket mandsaur",
      "sports ground mandsaur",
      "turf near me mandsaur"
    ],
    tier: 3,
    showBookNow: true
  },
  ratlam: {
    id: "0a406cd0-912a-48a8-a609-94ef341b6403",
    name: "Ratlam",
    slug: "ratlam",
    state: "Madhya Pradesh",
    latitude: 23.3315,
    longitude: 75.0367,
    keywords: [
      "turf booking ratlam",
      "cricket turf ratlam",
      "football turf ratlam",
      "box cricket ratlam",
      "sports ground ratlam",
      "turf near me ratlam"
    ],
    tier: 3,
    showBookNow: false
  },
  neemuch: {
    id: "97a42611-fd37-4a53-aee0-d035450f3be4",
    name: "Neemuch",
    slug: "neemuch",
    state: "Madhya Pradesh",
    latitude: 24.4700,
    longitude: 74.8700,
    keywords: [
      "turf booking neemuch",
      "cricket turf neemuch",
      "football turf neemuch",
      "box cricket neemuch",
      "sports ground neemuch",
      "turf near me neemuch"
    ],
    tier: 3,
    showBookNow: true
  },
  mhow: {
    id: "389269c6-4330-4961-9a46-db77d2b804a7",
    name: "Mhow",
    slug: "mhow",
    state: "Madhya Pradesh",
    latitude: 22.5500,
    longitude: 75.7500,
    keywords: [
      "turf booking mhow",
      "cricket turf mhow",
      "football turf mhow",
      "box cricket mhow",
      "sports ground mhow",
      "turf near me mhow"
    ],
    tier: 3,
    showBookNow: true
  },
  gandhinagar: {
    id: "3cda6e20-27a4-4449-a8f2-30d545bdd2f8",
    name: "Gandhinagar",
    slug: "gandhinagar",
    state: "Gujarat",
    latitude: 23.2156,
    longitude: 72.6369,
    keywords: [
      "turf booking gandhinagar",
      "cricket turf gandhinagar",
      "football turf gandhinagar",
      "box cricket gandhinagar",
      "sports ground gandhinagar",
      "turf near me gandhinagar"
    ],
    tier: 3,
    showBookNow: false
  },
  hubbali: {
    id: "f76c0d1d-655a-4573-821e-b9116801bdd2",
    name: "Hubbali",
    slug: "hubbali",
    state: "Karnataka",
    latitude: 15.3647,
    longitude: 75.1240,
    alternateNames: ["Hubli", "Hubballi"],
    keywords: [
      "turf booking hubbali",
      "turf booking hubli",
      "cricket turf hubbali",
      "football turf hubbali",
      "box cricket hubbali",
      "sports ground hubbali",
      "turf near me hubbali"
    ],
    tier: 3,
    showBookNow: true
  },
  jalandhar: {
    id: "039f07b2-c1d9-4548-b1df-31b5c143c5c7",
    name: "Jalandhar",
    slug: "jalandhar",
    state: "Punjab",
    latitude: 31.3260,
    longitude: 75.5762,
    keywords: [
      "turf booking jalandhar",
      "cricket turf jalandhar",
      "football turf jalandhar",
      "box cricket jalandhar",
      "sports ground jalandhar",
      "turf near me jalandhar"
    ],
    tier: 3,
    showBookNow: false
  },
  haryana: {
    id: "d60ad2a6-06f3-4b93-a845-f19defa92070",
    name: "Haryana",
    slug: "haryana",
    state: "Haryana",
    latitude: 29.0588,
    longitude: 76.0856,
    keywords: [
      "turf booking haryana",
      "cricket turf haryana",
      "football turf haryana",
      "box cricket haryana",
      "sports ground haryana",
      "turf near me haryana",
      "online turf booking haryana",
      "book turf haryana"
    ],
    tier: 3,
    showBookNow: false
  },
  hisar: {
    id: "2eaaf4c6-3290-4745-bed4-3b789f402f80",
    name: "Hisar",
    slug: "hisar",
    state: "Haryana",
    latitude: 29.1492,
    longitude: 75.7217,
    keywords: [
      "turf booking hisar",
      "cricket turf hisar",
      "football turf hisar",
      "box cricket hisar",
      "sports ground hisar",
      "turf near me hisar",
      "online turf booking hisar",
      "book turf hisar"
    ],
    tier: 3,
    showBookNow: true
  },
  dehradun: {
    id: "d562b6ad-490b-453c-884c-d257e686811b",
    name: "Dehradun",
    slug: "dehradun",
    state: "Uttarakhand",
    latitude: 30.3165,
    longitude: 78.0322,
    keywords: [
      "turf booking dehradun",
      "cricket turf dehradun",
      "football turf dehradun",
      "box cricket dehradun",
      "sports ground dehradun",
      "turf near me dehradun",
      "online turf booking dehradun",
      "book turf dehradun"
    ],
    tier: 2,
    showBookNow: true
  }
};

const normalizeCityValue = (value: string): string => {
  return value
    .normalize("NFKD")
    .replace(/[\u0300-\u036f]/g, "")
    .trim()
    .toLowerCase()
    .replace(/&/g, " and ")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .replace(/-{2,}/g, "-");
};

const getCityAliases = (city: CityData): string[] => {
  return [
    city.slug,
    city.name,
    ...(city.alternateNames || []),
  ];
};

const cityLookupMap: Record<string, CityData> = Object.values(cityDataMap).reduce(
  (lookup, city) => {
    getCityAliases(city).forEach((alias) => {
      const normalizedAlias = normalizeCityValue(alias);
      if (normalizedAlias) {
        lookup[normalizedAlias] = city;
      }
    });
    return lookup;
  },
  {} as Record<string, CityData>
);

export const normalizeCitySlug = (cityValue: string): string => {
  return normalizeCityValue(cityValue);
};

export const getCanonicalCitySlug = (cityValue: string): string => {
  const normalized = normalizeCityValue(cityValue);
  return cityLookupMap[normalized]?.slug || normalized;
};

export const areCitiesEquivalent = (left?: string | null, right?: string | null): boolean => {
  if (!left || !right) return false;
  return getCanonicalCitySlug(left) === getCanonicalCitySlug(right);
};

/**
 * Get city data by slug, display name, or alternate name
 */
export const getCityData = (citySlug: string): CityData | null => {
  const normalized = normalizeCityValue(citySlug);
  return cityLookupMap[normalized] || null;
};

export const createDynamicCityData = ({
  id,
  name,
  showBookNow = false,
  state = "India",
}: {
  id?: string;
  name: string;
  showBookNow?: boolean;
  state?: string;
}): CityData => {
  const canonicalSlug = getCanonicalCitySlug(name);
  const formattedName = formatCityName(name);

  return {
    id: id || `dynamic-${canonicalSlug}`,
    name: formattedName,
    slug: canonicalSlug,
    state,
    latitude: 0,
    longitude: 0,
    keywords: [
      `turf booking ${canonicalSlug}`,
      `cricket turf ${canonicalSlug}`,
      `football turf ${canonicalSlug}`,
    ],
    tier: 3,
    showBookNow,
  };
};

/**
 * Get all cities
 */
export const getAllCities = (): CityData[] => {
  return Object.values(cityDataMap);
};

/**
 * Get cities by tier
 */
export const getCitiesByTier = (tier: 1 | 2 | 3): CityData[] => {
  return getAllCities().filter(city => city.tier === tier);
};

/**
 * Get cities with booking enabled
 */
export const getCitiesWithBooking = (): CityData[] => {
  return getAllCities().filter(city => city.showBookNow);
};

/**
 * Get state for city
 */
export const getStateForCity = (citySlug: string): string => {
  const data = getCityData(citySlug);
  return data?.state || "India";
};

/**
 * Get city coordinates
 */
export const getCityCoordinates = (citySlug: string): { latitude: number; longitude: number } | null => {
  const data = getCityData(citySlug);
  if (!data) return null;
  return {
    latitude: data.latitude,
    longitude: data.longitude
  };
};

/**
 * Get city keywords
 */
export const getCityKeywords = (citySlug: string): string[] => {
  const data = getCityData(citySlug);
  return data?.keywords || [];
};

/**
 * Get alternate names for city
 */
export const getCityAlternateNames = (citySlug: string): string[] => {
  const data = getCityData(citySlug);
  return data?.alternateNames || [];
};

/**
 * Check if city exists
 */
export const cityExists = (citySlug: string): boolean => {
  return getCityData(citySlug) !== null;
};

/**
 * Format city name (capitalize first letter)
 * Fallback function if city not found in data
 */
export const formatCityName = (citySlug: string): string => {
  const city = getCityData(citySlug);
  if (city) {
    return city.name;
  }
  // Fallback: capitalize first letter
  return citySlug
    .split(/[-\s]+/)
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase())
    .join(" ");
};
